import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getStartupProgress } from '../../../features/session/sessionSlice'

const INITIAL_PROGRESS_BAR_HEIGHT = 4

function StartupButton({ onClick }){
    const dispatch = useDispatch()
    const onboarding = useSelector(state => state.session.onboarding)
    const model = useSelector(state => state.site.model)

    const [progressBarHeight, setProgressBarHeight] = useState(INITIAL_PROGRESS_BAR_HEIGHT)

    const site = model?.sites && model?.siteActiveIdx ? model?.sites[model.siteActiveIdx] : {}

    useEffect(() => {
        dispatch(getStartupProgress())
    }, [])

    return <div className="border border-white" id="startupBtn">
        <button className="btn-block btn btn-grad" onMouseOut={() => setProgressBarHeight(4)} onMouseOver={() => setProgressBarHeight(12)} onClick={(e) => onClick(e)}><i class="far fa-list-alt"></i> Startup Checklist</button>
        <div class="progress" style={{height: `${progressBarHeight}px`}}>
            <div class="progress-bar bg-success font-weight-bold" role="progressbar" style={{width: `${onboarding.startupStats.progress}%`}} aria-valuemin="0" aria-valuemax="100">
                {progressBarHeight === INITIAL_PROGRESS_BAR_HEIGHT ? "" : `${onboarding.startupStats.progress}%`}
            </div>
        </div>
    </div>
}

export default StartupButton